import { FormEvent, useState } from "react";
import { ApiError } from "../../api/client";
import {
  CustomerRow,
  resetCustomerAdminPassword,
  ResetAdminPasswordResult,
} from "../../api/platformCustomers";

type Props = {
  customer: CustomerRow;
  onClose: () => void;
  onDone: (result: ResetAdminPasswordResult) => void;
};

export function ResetCustomerPasswordModal({ customer, onClose, onDone }: Props) {
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState<ResetAdminPasswordResult | null>(null);

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const result = await resetCustomerAdminPassword(customer.id, password);
      setDone(result);
    } catch (err: unknown) {
      setError(err instanceof ApiError ? err.message : "Parola sifirlanamadi.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="kp-modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className="kp-card kp-customer-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="kp-reset-customer-pw-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="kp-customer-modal__head">
          <h3 id="kp-reset-customer-pw-title">Parola Sıfırla</h3>
          <button type="button" className="kp-btn kp-btn--ghost" onClick={onClose} disabled={busy}>
            Kapat
          </button>
        </div>

        {!done ? (
          <form className="kp-customer-modal__form" onSubmit={handleSubmit}>
            <p className="kp-muted">
              <strong>{customer.name}</strong>
              {customer.admin_name || customer.admin_email ? (
                <>
                  {" "}
                  — {customer.admin_name || "Yönetici"}
                  {customer.admin_email ? ` (${customer.admin_email})` : ""}
                </>
              ) : null}
            </p>

            <label className="kp-customer-field">
              <span>
                Yeni geçici parola <em>*</em>
              </span>
              <input
                className="kp-input"
                type="text"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={8}
                maxLength={128}
                placeholder="En az 8 karakter"
                disabled={busy}
              />
              <small className="kp-muted">
                Müşteriye iletin. İlk girişte şifre değiştirmesi istenir.
              </small>
            </label>

            {error && <div className="kp-customer-modal__error">{error}</div>}

            <div className="kp-customer-modal__actions">
              <button type="button" className="kp-btn" onClick={onClose} disabled={busy}>
                İptal
              </button>
              <button
                type="submit"
                className="kp-btn kp-btn--primary"
                disabled={busy || password.length < 8}
              >
                {busy ? "Kaydediliyor…" : "Sıfırla"}
              </button>
            </div>
          </form>
        ) : (
          <div className="kp-customer-modal__form">
            <div className="kp-customers__success" role="status">
              <strong>Parola sıfırlandı</strong>
              <p>{done.login_hint}</p>
              <p>Yeni parolayı müşteriye güvenli kanaldan iletin.</p>
            </div>
            <div className="kp-customer-modal__actions">
              <button
                type="button"
                className="kp-btn kp-btn--primary"
                onClick={() => {
                  onDone(done);
                  onClose();
                }}
              >
                Tamam
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
